var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ dark: _vm.$route.meta.header === 'dark', scrolled: _vm.scrolled }},[_c('div',{staticClass:"main-header"},[_c('div',{staticClass:"container"},[_c('MainHeaderContent',{attrs:{"dark":!_vm.scrolled && _vm.$route.meta.header === 'dark'}})],1)]),_vm._v(" "),_c('div',{staticClass:"main-header-filler"})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d24aabe4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/MainHeader.vue
// module id = meCz
// module chunks = 1